import { AppVariableType } from '../../shared/constants';
import { ModelBase } from './model-base';

export const AppVariableKeys = {
  appStorageLink: 'APK_STORAGE_LINK',
  iosBuildLink: 'IOS_BUILD_LINK',
  apkFileName: 'APK_FILE_NAME',
  version: 'VERSION',
  lastSupportedVersion: 'LAST_SUPPORTED_VERSION',
  boostyUrl: 'BOOSTY_URL',
  patreonUrl: 'PATREON_URL',
  contactUsEmail: 'CONTACT_US_EMAIL',
  contactUsPhone: 'CONTACT_US_PHONE',
};

export interface IAppVariable extends ModelBase {
  key: string;
  type: AppVariableType;
  value: string;
}

/** Matches app variable `key` case-insensitively; ignores empty `value`. */
export function getAppVariableValueInsensitive(
  variables: IAppVariable[] | undefined,
  expectedKey: string,
): string | undefined {
  if (!variables?.length) {
    return undefined;
  }
  const needle = expectedKey.trim().toUpperCase();
  const row = variables.find((v) => v.key?.trim().toUpperCase() === needle);
  const raw = row?.value?.trim();
  return raw || undefined;
}
